// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QPdY8","comment":"styles_comment__3DM8K"};